import { useClient } from 'hooks/useClient';
import { useQuery } from 'react-query';
import { resolveTokenV3 } from 'helpers/sessionContext';
import { useSession } from 'store/session';
import { useTranslation } from 'react-i18next';
import { useToast } from '@chakra-ui/react';
import { ERROR_TOAST_DEFAULTS } from '@helpers';
import { translations } from 'translations';

export const useFetchReminder = ({
  folder,
  document,
  team,
  invite,
  enabled,
}) => {
  const { t } = useTranslation();
  const toast = useToast();
  const client = useClient({
    url: process.env.REACT_APP_API_V3,
    token: resolveTokenV3(),
  });

  const { team: defaultTeam } = useSession();

  const teamUUID = defaultTeam?.uuid as string;

  const query = useQuery(
    ['fetch-document-invite', invite],
    async () => {
      try {
        if (typeof invite === 'undefined') return;

        const response = await client.resendInvitationV3(
          team ?? teamUUID,
          folder,
          document,
          invite,
        );

        toast({
          position: 'top-right',
          isClosable: true,
          title: t(translations.SUCCESS.REMINDER_SENT),
          status: 'success',
        });

        return response;
      } catch (err) {
        const error = (err as any).response.status;

        if (error === 429) {
          toast({
            ...ERROR_TOAST_DEFAULTS,
            title: t(translations.INVITES.STATUS_CODE_429),
          });
        }
      }
    },
    {
      enabled,
    },
  );

  return { ...query };
};
